import { IconButton } from '@saucelabs/ds-button';
import { IconThumbsDownFill, IconThumbsUpFill } from '@saucelabs/ds-icons';
import classnames from 'classnames';
import React, { forwardRef } from 'react';

import Styles from './DecideButton.styles';

export enum DecideButtonTypes {
  ACCEPT = 'ACCEPT',
  REJECT = 'REJECT'
}

type DecideProps = {
  isActive: boolean;
  type: DecideButtonTypes;
  onClick: () => void;
  onUnapprove: () => void;
  className?: string;
}

type AcceptProps = DecideProps & {
  isNoChanges?: boolean;
  type: DecideButtonTypes.ACCEPT;
}

type RejectProps = DecideProps & {
  isNoChanges?: never;
  type: DecideButtonTypes.REJECT;
}

type Props = AcceptProps | RejectProps

const BUTTON_TYPES: Record<DecideButtonTypes, { active: string, icon: JSX.Element }> = {
  [DecideButtonTypes.ACCEPT]: { active: 'accepted', icon: <IconThumbsUpFill /> },
  [DecideButtonTypes.REJECT]: { active: 'rejected', icon: <IconThumbsDownFill /> },
};

const DecideButton = forwardRef<
  HTMLButtonElement, Props
>(({ isActive, isNoChanges, onClick, onUnapprove, type, className, ...other }, forwardedRef) => (
  <IconButton
    ref={forwardedRef}
    {...other}
    aria-pressed={isActive}
    className={classnames(className, {
      [Styles[BUTTON_TYPES[type].active]]: isActive,
      [Styles['no-changes']]: !isActive && isNoChanges,
      [Styles.default]: !isActive && !isNoChanges,
      [Styles['reject-default']]: type === DecideButtonTypes.REJECT && !isActive,
      [Styles['accept-default']]: type === DecideButtonTypes.ACCEPT && !isActive,
    })}
    color={isActive ? 'primary' : 'secondary'}
    icon={BUTTON_TYPES[type].icon}
    onPress={isActive ? onUnapprove : onClick}
    size="md"
    variant={isActive ? 'contained' : 'outline'}
  />
));

export default DecideButton;
